import type { JawOutlineTooth } from '@witmetrics/utils';

export const TEETH: JawOutlineTooth[] = [
  'tooth1',
  'tooth2',
  'tooth3',
  'tooth4',
  'tooth5',
  'tooth6',
  'tooth7',
  'tooth8',
];

export const LABELS: Record<JawOutlineTooth, string> = {
  tooth1: 'Tooth 1',
  tooth2: 'Tooth 2',
  tooth3: 'Tooth 3',
  tooth4: 'Tooth 4',
  tooth5: 'Tooth 5',
  tooth6: 'Tooth 6',
  tooth7: 'Tooth 7',
  tooth8: 'Tooth 8',
};
